const css = `.mQhZTG__table{color:var(--base-text-default)}.mQhZTG__tableHeader{z-index:2}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tableHeader":"mQhZTG__tableHeader","table":"mQhZTG__table"};
